// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2oLLX","title":"InfoRow_title__1Af49"};